export default __webpack_public_path__ + "static/media/1.e24b74f4.png";